import { useEffect, useState } from "react";
import { getIn, useFormikContext } from "formik";
import AutocompleteFormik from "../../../../../common/components/form/AutocompleteFormik";

export function FipeYearModelFieldFormik() {
    const [options, setOptions] = useState([])
    const formik = useFormikContext()
    const modelOptions = getIn(formik.values, 'fipeInfo.model')

    useEffect(() => {
        async function load() {
            if (!modelOptions || !modelOptions.availableYears) {
                setOptions([])
                return
            }

            setOptions(modelOptions.availableYears)
        }

        load()
    }, [modelOptions])

    return (
        <AutocompleteFormik
            label="Ano do modelo:"
            name="fipeInfo.yearModel"
            valueProperty="fipeId"
            allowNewItem={true}
            options={options}
        />
    )
}